import '../../css-tokens';
import React from 'react';
import styles from './index.module.css';
const ChoiceImage = _ref => {
  let {
    src,
    alt
  } = _ref;
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    className: styles.image
  });
};
export default ChoiceImage;